import { incomingMessage } from './actions/actions';
import { settings } from '../../../settings/settings-util'
import reducer from './reducers/index';
import Guid from 'uuid';

/**
 * ClientCommunicator is responsible for communicating with the client web site. 
 * This class allows client web site and Next IT IVA to communicate
 * with each other without using each other's object directly
*/
export default class ClientCommunicator {
    constructor(passedSettings) {
        this._settings = passedSettings || settings;
    }

    static getDefaultSettings() {
        return settings;
    }

    getReducer() {
        return reducer;
    }

    initialize(store) {
        this._store = store;

        //Wire to the message event
        window.addEventListener("message", (event) => {
            this.processIncoming(event);
        });
        
        // There's a * in here. Warn and override now-useless validator.
        if (this.allAllowed) {
            if (process.env.NODE_ENV !== 'production') {
                console.error(
`Because allowed origins contains "*", 
all origins are allowed for Alme postMessage. 
This is not recommended. 
Please consider restricting to subdomains.

This message is hidden in the production build.
`);
}
            this.validateOrigin = () => true;
        }
    }

    /**
     * Used for processing the incoming messages from the windows post message API
     * @param {} messageEvent 
     * @returns {} - doesn't return a value  
     */
    processIncoming(messageEvent) {
        if (this.windowIsBlocked) {
            return;
        }

        if (!this.validateOrigin(messageEvent) || !this.validateSource(messageEvent)) {
            return;
        }

        // Message from client
        let data = JSON.parse(messageEvent.data);

        if (process.env.console_logging_enabled) {
            console.log(data);
        }
        // Assign ID to message
        data.message = Object.assign({},
            data.message, 
            {
                id: Guid.v4(),
                createDateTime: (new Date()).getTime(),
                isProcessed: false 
            }
        );

        const payload = { message: data.message };
        const stateLocation = this._settings.stateLocations.ClientCommunicator.ReceivedMessages;
        // Pass whitelist to reducer 
        const { AllowMultipleWhitelist } =  this._settings.CommunicationConstants;
        this._store.dispatch(incomingMessage(stateLocation, payload, AllowMultipleWhitelist));
    }

    // * = anything allowed; fancy validation is redundant
    get allAllowed() {
        return this.allowedOrigins.includes('*');
    }

    get allowedOrigins() {
        const { Base, AllowedOrigins } = this._settings.stateLocations.ClientCommunicator;
        const state = this._store.getState();
        return state[Base][AllowedOrigins];
    }

    // Army-specific requirement (cussing)
    get windowIsBlocked() {
        const { Base, IsBlocked } = this._settings.stateLocations.Window;
        const state = this._store.getState();
        return IsBlocked && state[Base][IsBlocked];
    }

    /**
     * Validate if we are getting the message event from the expected origin
     * @param {} messageEvent 
     * @returns {boolean}
     */
    validateOrigin(messageEvent) {
        const messageOrigin = messageEvent.origin.toLowerCase();
        // Allow messages from main window (i.e. page including Alme scripts). 
        // Probably not a security concern - focus on 3rd-party scripts.
        if (messageOrigin === window.location.origin) {
            return true;
        }

        const allowedOrigins = this.allowedOrigins || [];

        for (const origin of allowedOrigins) {
            const lcOrigin = origin.toLowerCase();

            // Exact match: www.domain.com
            if (messageOrigin === lcOrigin) {
                return true;
            }

            // *.domain.com -> sub1.domain.com, sub2.domain.com
            if (lcOrigin[0] === '*') {
                const suffix = lcOrigin.substring(1);
                // N.B. this works with very loose things like "*.com"
                if (suffix && messageOrigin.endsWith(suffix)) {
                    return true;
                }
            }
        }

        return false;
    }

    /**
     * Validate if source of the message is client and not nit
     * @param {} messageEvent 
     * @returns {boolean}
     */
    validateSource(messageEvent) {
        if (!messageEvent.data) return false;

        var data;
        try {
            data = JSON.parse(messageEvent.data);
        } catch (e) {
            //This JSON string is likely coming from XDomain which it contains [object, object] which parse will throw exception for
            return false;
        }

        if (!data || !data.message || !data.message.source) return false;

        return this._settings.CommunicationConstants.Source.Client.toLowerCase() === data.message.source.toLowerCase();
    }

    currentPageOrigin() {
        return window.location.origin;
    }
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/clientcommunicator/src/clientcommunicator.js